const helper = {
    Sleep(ms: number = 0): Promise<void>
    {
        return new Promise(r => setTimeout(r, ms))
    }
}

export { helper as PromiseHelper }
